<template>
  <div class="c-version__loading-icon-container">
    <LoadingIcon v-if="isLoading" />
  </div>
  <template v-if="!isExternal">
    <ProjectVersions
      :key="componentKey"
      :project-id="projectId"
      :project-documentation="projectDocumentation"
      :request-user="requestUser"
      :is-authenticated="isAuthenticated"
      :is-premium-project="isPremiumProjectBool"
      :is-premium-user="isPremiumUserBool"
      :is-vip-user="isVip"
      :is-internal-user="isInternal"
      :is-admin-user="isAdmin"
      @vue:mounted="onComponentMounted"
      @rerender="forceRerender"
    />
  </template>
  <template v-else>
    <ProjectExternalVersions
      :key="componentKey"
      :project-id="projectId"
      :project-documentation="projectDocumentation"
      :request-user="requestUser"
      :is-authenticated="isAuthenticated"
      @vue:mounted="onComponentMounted"
      @rerender="forceRerender"
    />
  </template>
</template>

<script setup lang="ts">
import { ref, toRefs } from 'vue'
import ProjectVersions from '@/components/ProjectVersions.ce.vue'
import ProjectExternalVersions from '@/components/ProjectExternalVersions.ce.vue'
import LoadingIcon from '@/components/LoadingIcon.vue'

const props = defineProps<{
  projectId: number
  projectDocumentation?: string
  requestUser: string
  userEmail: string
  isUserAuthenticated: string
  isExternal?: boolean
  isPremiumProject: string
  isPremiumUser: string
  isVipUser: string
  isInternalUser: string
  isAdminUser: string
}>()

const { projectId } = toRefs(props)
const { projectDocumentation } = toRefs(props)
const { requestUser } = toRefs(props)
const { userEmail } = toRefs(props)
const { isUserAuthenticated } = toRefs(props)
const { isPremiumProject } = toRefs(props)
const { isPremiumUser } = toRefs(props)
const { isVipUser } = toRefs(props)
const { isInternalUser } = toRefs(props)
const { isAdminUser } = toRefs(props)

const isPremiumProjectBool = ref(false)
// check if project is premium as props is a string and not a boolean
if (isPremiumProject.value.includes('True')) {
  isPremiumProjectBool.value = true
} else {
  isPremiumProjectBool.value = false
}

const isAuthenticated = ref(false)
// check if user is authenticated as props is a string and not a boolean
if (isUserAuthenticated.value.includes('True')) {
  isAuthenticated.value = true
} else {
  isAuthenticated.value = false
}

const isPremiumUserBool = ref(false)
// check if user is premium as props is a string and not a boolean
if (isPremiumUser.value.includes('True')) {
  isPremiumUserBool.value = true
} else {
  isPremiumUserBool.value = false
}

const isVip = ref(false)
// check if user is vip as props is a string and not a boolean
if (isVipUser.value.includes('True')) {
  isVip.value = true
} else {
  isVip.value = false
}

const isInternal = ref(false)
// check if user is internal as props is a string and not a boolean
if (isInternalUser.value.includes('True')) {
  isInternal.value = true
} else {
  isInternal.value = false

  if (userEmail.value) {
    if (userEmail.value.includes('@ircam.fr')) {
      isInternal.value = true
    }
  }
}

const isAdmin = ref(false)
// check if user is admin as props is a string and not a boolean
if (isAdminUser.value.includes('True')) {
  isAdmin.value = true
} else {
  isAdmin.value = false
}

const projectUserInfos = {
  'is authenticated': isAuthenticated.value,
  'is premium project': isPremiumProjectBool?.value,
  'is premium user': isPremiumUserBool?.value,
  'is vip user': isVip?.value,
  'is internal user': isInternal.value,
  'is admin user': isAdmin.value
}
console.log('INFOS: ', projectUserInfos)

const componentKey = ref(0)

const isLoading = ref(true)

function onComponentMounted () {
  isLoading.value = false
}

const forceRerender = () => {
  isLoading.value = true

  componentKey.value += 1
  // console.log('RERENDER')
}

</script>
